export default {
  Placeholder: {
    EnterLocation: 'Quận/Huyện, Tỉnh/Thành phố',
    ChooseSchool: 'Đơn vị đang công tác (Không bắt buộc)',
    SurName: 'Họ và tên đệm',
    Name: 'Tên',
    EnterPhoneNumber: 'Số điện thoại',
    EnterEmail: 'Email',
    EnterUserName: 'Tên đăng nhập',
    EnterFullName: 'Họ và tên',
    NotRequire: 'Không bắt buộc',
    EnterEmailOrPhoneNumber: 'Email hoặc số điện thoại',
    EnterPassword: 'Mật khẩu',
    ConfirmPassword: 'Xác nhận lại mật khẩu',
    EnterNewPassword: 'Mật khẩu mới',
    EnterBirthday: 'Ngày tháng năm sinh',
    EnterCodeVerify: 'Mã xác thực',
    EnterCodeAbove: 'Đoạn mã phía trên',
    OrganizationName: 'Tên trường học/trung tâm đào tạo',
    Location: 'Quận/Huyện, Tỉnh/Thành phố',
    FullName: 'Họ và tên',
    Position: 'Vị trí công tác',
    PhoneNumber: 'Số điện thoại',
    EnterInfoHere: 'Thông tin tại đây...'
  }
}
